import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Instagram } from "lucide-react";
import { CONTACT, SERVICE_AREAS } from "@/data/content";

const SERVICE_LINKS = [
  { label: "Waterproofing", to: "/services/waterproofing" },
  { label: "Concrete Repairs", to: "/services/remediation" },
  { label: "Crack Injection", to: "/services/remediation" },
  { label: "Rising Damp Treatment", to: "/services/remediation" },
  { label: "Rendering", to: "/services/rendering" },
  { label: "Plastering", to: "/services/plastering" },
  { label: "Microcement", to: "/services/microcement" },
  { label: "All Services", to: "/services" },
];

const COMPANY_LINKS = [
  { label: "Portfolio", to: "/portfolio" },
  { label: "About CEMTEX", to: "/about" },
  { label: "Testimonials", to: "/testimonials" },
  { label: "Contact", to: "/contact" },
  { label: "Get a Free Quote", to: "/contact" },
];

export default function Footer() {
  return (
    <footer className="bg-charcoal text-white" data-testid="site-footer">
      <div className="container-x py-20 md:py-28">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 lg:gap-16">
          {/* Brand */}
          <div className="md:col-span-4">
            <div className="font-display text-3xl tracking-[0.15em] font-extrabold mb-6">CEMTEX</div>
            <p className="text-white/60 font-light leading-relaxed max-w-sm text-sm">
              Specialist surface solutions and remediation — waterproofing, concrete repairs, crack injection, rising damp treatment, rendering, plastering and microcement. Across Perth Metro and Regional Western Australia.
            </p>
          </div>

          {/* Services */}
          <div className="md:col-span-2">
            <h4 className="eyebrow !text-white/50 mb-6 !text-[0.65rem]">Services</h4>
            <ul className="space-y-3">
              {SERVICE_LINKS.map((s) => (
                <li key={s.label}><Link to={s.to} className="text-sm text-white/70 hover:text-sand transition-colors font-light">{s.label}</Link></li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div className="md:col-span-2">
            <h4 className="eyebrow !text-white/50 mb-6 !text-[0.65rem]">Company</h4>
            <ul className="space-y-3">
              {COMPANY_LINKS.map((c) => (
                <li key={c.label}><Link to={c.to} className="text-sm text-white/70 hover:text-sand transition-colors font-light">{c.label}</Link></li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="md:col-span-4">
            <h4 className="eyebrow !text-white/50 mb-6 !text-[0.65rem]">Contact</h4>
            <ul className="space-y-4 mb-8">
              <li><a href={CONTACT.phoneHref} className="flex items-center gap-3 text-sm text-white/80 hover:text-sand transition-colors"><Phone className="h-4 w-4 text-sand" strokeWidth={1.5} /> {CONTACT.phone}</a></li>
              <li><a href={`mailto:${CONTACT.email}`} className="flex items-center gap-3 text-sm text-white/80 hover:text-sand transition-colors"><Mail className="h-4 w-4 text-sand" strokeWidth={1.5} /> {CONTACT.email}</a></li>
              <li className="flex items-center gap-3 text-sm text-white/80"><MapPin className="h-4 w-4 text-sand" strokeWidth={1.5} /> {CONTACT.location}</li>
              <li><a href={CONTACT.instagram} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" className="flex items-center gap-3 text-sm text-white/80 hover:text-sand transition-colors"><Instagram className="h-4 w-4 text-sand" strokeWidth={1.5} /> {CONTACT.instagramHandle}</a></li>
            </ul>
            <h4 className="eyebrow !text-white/50 mb-3 !text-[0.65rem]">Service Areas</h4>
            <p className="text-xs text-white/50 leading-relaxed font-light">{SERVICE_AREAS.join(" · ")}</p>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
          <p className="text-xs text-white/40">© 2026 CEMTEX. All rights reserved. Perth, Western Australia.</p>
          <div className="flex gap-6">
            <span className="text-xs text-white/40 hover:text-sand transition-colors cursor-pointer">Privacy Policy</span>
            <span className="text-xs text-white/40 hover:text-sand transition-colors cursor-pointer">Terms of Service</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
